import { Checkbox, Touchable } from '@/components'
import { Chat } from '@/config/packages'
import { createStyles } from '@codeleap/styles'
import { isMessageDeleted, isPollMessage, isThreadParentMessage } from '@packages/chat'
import { useMessageContext } from 'stream-chat-react'
import { MessageProps } from '../types'

type MessageCheckboxProps = MessageProps & {
  isChecked?: boolean
  onClick: () => void
  isSelected?: boolean
}

export const MessageCheckboxWithContext = ({ onClick, isChecked }: MessageCheckboxProps) => {

  return (
    <Touchable
      debugName='MessageCheckbox'
      style={styles.wrapper}
      onPress={onClick}
    >
      <Checkbox
        style={['circle']}
        value={isChecked}
        onValueChange={onClick}
      />
    </Touchable>
  )
}

const styles = createStyles(theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing.value(2),
    cursor: 'pointer',
    pointerEvents: 'auto',
    alignSelf: 'center',
  },
}))

export const MessageCheckbox = ({ onClick, isSelected, ...props }: MessageCheckboxProps) => {
  const { selectModeActive } = Chat.Store.useSelectMode({ threadList: props.threadList })
  const selectMode = Chat.Store.state.use(s => s.selectMode)
  const { message } = useMessageContext()

  if (!selectModeActive) return null

  if (isMessageDeleted(message)) return null

  if (isThreadParentMessage(message, props.threadList)) return null

  if (isPollMessage(message) && selectMode === 'forward') return null

  if (selectMode === 'delete' && !props?.isMyMessage()) return null

  return <MessageCheckboxWithContext {...props} onClick={onClick} isChecked={isSelected} />
}
